import Badge from '@mui/material/Badge';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { m } from 'framer-motion';
import { varHover } from 'src/components/animate';
import AppLoadingAndErrorWrapper from 'src/components/appComponents/AppLoadingAndErrorWrapper';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { useBoolean } from 'src/hooks/use-boolean';
import { useResponsive } from 'src/hooks/use-responsive';
import NotificationItem from './notification-item';
import { useGetAllAdminNotificationsQuery, useUpdateAdminNotificationsMutation } from 'src/graphql';
import { useQueryClient } from '@tanstack/react-query';

// ----------------------------------------------------------------------

export default function NotificationsPopover() {
  const drawer = useBoolean();
  const queryClient = useQueryClient();
  const smUp = useResponsive('up', 'sm');
  const accessUserRaw = localStorage.getItem('accessUser');
  const accessUser = accessUserRaw ? JSON.parse(accessUserRaw) : null;

  const { data, isLoading } = useGetAllAdminNotificationsQuery({ adminId: accessUser?.id });

  const todayNotifications = data?.admin_notifications;

  const notificationsCount = data?.admin_notifications_aggregate?.aggregate?.count;

  const { mutate: UpdateAdminNotifications, isLoading: isLoadingUpdateAdminNotifications } =
    useUpdateAdminNotificationsMutation({
      onSuccess: () => {
        queryClient.refetchQueries(['GetAllAdminNotifications']);
      },
    });

  const noNotifications = (
    <Stack alignItems="center" my="auto">
      <Typography variant="h6" sx={{ flexGrow: 1, color: 'text.disabled' }}>
        There are no notifications
      </Typography>
    </Stack>
  );

  const renderHead = (
    <Stack direction="row" alignItems="center" sx={{ py: 2, pl: 2.5, pr: 1, minHeight: 68 }}>
      <Typography variant="h6" sx={{ flexGrow: 1 }}>
        Notifications
      </Typography>

      {!smUp && (
        <IconButton onClick={drawer.onFalse}>
          <Iconify icon="mingcute:close-line" />
        </IconButton>
      )}
    </Stack>
  );

  return (
    <>
      {/* Notifications Icon Buton */}
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        color={drawer.value ? 'primary' : 'default'}
        onClick={() => {
          UpdateAdminNotifications({});
          drawer.onTrue();
        }}
      >
        <Badge badgeContent={notificationsCount} color="error">
          <Iconify icon="solar:bell-bing-bold-duotone" width={24} />
        </Badge>
      </IconButton>

      <Drawer
        open={drawer.value}
        onClose={drawer.onFalse}
        anchor="right"
        slotProps={{
          backdrop: { invisible: true },
        }}
        PaperProps={{
          sx: { width: 1, maxWidth: 420 },
        }}
      >
        {renderHead}

        <Divider />

        <AppLoadingAndErrorWrapper isLoading={isLoading}>
          <Divider />
          {todayNotifications?.length == 0 ? (
            noNotifications
          ) : (
            <Scrollbar>
              <List disablePadding>
                {todayNotifications?.map((notification: any) => (
                  <NotificationItem
                    key={notification.id}
                    notification={notification}
                    onCloseDrawer={drawer.onFalse}
                  />
                ))}
              </List>
            </Scrollbar>
          )}
        </AppLoadingAndErrorWrapper>
      </Drawer>
    </>
  );
}
